<script setup lang="ts">
  import IconRadio from '@/shared/ui/inputs/IconRadio.vue';

  interface Props {
    primary: string;
    secondary: string;
    text: string;
    radioName: string;
  }

  defineProps<Props>();

  const emit = defineEmits<{
    (e: 'update:primary', value: string): void;
    (e: 'update:secondary', value: string): void;
    (e: 'update:text', value: string): void;
  }>();

  const TEXT_OPTIONS = [
    { value: '#2F2F2F', label: 'Preto' },
    { value: '#FFFFFF', label: 'Branco' },
  ];

  const hexLabel = (color: string) => color.replace('#', '').toUpperCase();
</script>

<template>
  <div class="grid grid-cols-3 gap-6">
    <div class="flex flex-col gap-2 text-left">
      <div class="font-medium">
        Cor primária:
      </div>
      <div class="text-sm text-gray-03">
        Background do menu lateral, dropzone, grupo de botões
      </div>
      <div class="flex items-center gap-2 mt-2">
        <input
          :value="primary"
          type="color"
          class="w-10 h-8 rounded cursor-pointer border border-gray-03"
          data-testid="primary-color-input"
          @input="emit('update:primary', ($event.target as HTMLInputElement).value)"
        >
        <span class="text-sm"># {{ hexLabel(primary) }}</span>
      </div>
    </div>

    <div class="flex flex-col gap-2 text-left">
      <div class="font-medium">
        Cor secundária:
      </div>
      <div class="text-sm text-gray-03">
        Cor de botões principais, checkbox, links e ícones ativos
      </div>
      <div class="flex items-center gap-2 mt-2">
        <input
          :value="secondary"
          type="color"
          class="w-10 h-8 rounded cursor-pointer border border-gray-03"
          data-testid="secondary-color-input"
          @input="emit('update:secondary', ($event.target as HTMLInputElement).value)"
        >
        <span class="text-sm"># {{ hexLabel(secondary) }}</span>
      </div>
    </div>

    <div class="flex flex-col gap-2 text-left">
      <div class="font-medium">
        Cor Texto:
      </div>
      <div class="text-sm text-gray-03">
        Cor do texto do menu lateral e ícones do menu
      </div>
      <div class="flex items-center gap-4 mt-2">
        <IconRadio
          v-for="option in TEXT_OPTIONS"
          :key="option.value"
          :model-value="text"
          :name="radioName"
          :value="option.value"
          :label="option.label"
          @update:model-value="emit('update:text', $event)"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
  input[type='color'] {
    -webkit-appearance: none;
    padding: 0;
  }
  input[type='color']::-webkit-color-swatch-wrapper {
    padding: 0;
  }
  input[type='color']::-webkit-color-swatch {
    border: none;
    border-radius: 4px;
  }
</style>
